import { useQueryClient } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';

import AppContext from '@/contexts/appContext';

export const useQueryResponseMessage = ({
  dataUpdatedAt,
  isSuccess,
  queryKey,
  successMessage
}: {
  dataUpdatedAt: number;
  isSuccess: boolean;
  queryKey: Array<string>;
  successMessage: string;
}) => {
  const { addMessage } = useContext(AppContext);
  const queryClient = useQueryClient(); // Access the query client{

  useEffect(() => {
    const query = queryClient.getQueryData(queryKey);

    // Safely check if messageShown exists or not, using type assertion
    const hasMessageShown = (query as { messageShown?: boolean })?.messageShown;

    // Only trigger if data is successful, valid, and message hasn't been shown yet
    if (isSuccess && query && !hasMessageShown) {
      addMessage({ level: 'success', text: successMessage });

      // Update the query data to mark that the message has been shown
      queryClient.setQueryData(queryKey, (oldQueryData: object) => ({
        ...oldQueryData,
        messageShown: true // Add custom flag
      }));
    }
  }, [addMessage, dataUpdatedAt, isSuccess, queryClient, queryKey, successMessage]);
};
